module.exports = __webpack_public_path__ + "img/avatar-s-26.0f4533ab.jpg";